import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.object.keys.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  class: "search-container"
};
var _hoisted_2 = {
  class: "date-select"
};
var _hoisted_3 = {
  class: "date-box"
};
var _hoisted_4 = {
  key: 0
};
import dayjs from 'dayjs';
/** 组合式api */
import { ref, reactive } from 'vue';
/** 接口 */
import { getMonthLesson } from '@/api/index-jiao.js';
export default {
  __name: 'topSearch',
  emits: ['handleSearch'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var emit = __emit;

    /** 初始化相关 */
    var form = reactive({
      date: null,
      //日期
      schoolId: null,
      // 学校id
      classId: null,
      // 班级
      lessonId: null //课堂id
    });
    var dateOptions = ref([]); //日期筛选
    var schoolOptions = ref([]); // 学校下拉
    var lessonOptions = ref([]); // 课堂下拉
    var classOptions = ref([]); // 班级下拉
    var dateIndex = ref(0); //当前日期数据
    /** 初始化相关_方法 */
    var getInitData = function getInitData() {
      var accessInfo = JSON.parse(localStorage.getItem('accessInfo'));
      getMonthLesson({
        userId: accessInfo.content.user_id
      }).then(function (res) {
        if (res.data.code === 0) {
          dateOptions.value = res.data.data || [];
          if (dateOptions.value.length) {
            var nowTime = dayjs().format('YYYY-MM-DD');
            dateIndex.value = dateOptions.value.findIndex(function (x) {
              return x.dayOfMonth === nowTime;
            });
            // console.log('dateIndex', dateIndex.value, nowTime)
            init();
          }
          handleSearch();
        }
      });
    };
    var init = function init() {
      form.date = dateOptions.value[dateIndex.value].dayOfMonthName;
      schoolOptions.value = dateOptions.value[dateIndex.value].deptCommonVOS;
      if (schoolOptions.value.length) {
        form.schoolId = schoolOptions.value[0].deptId;
        initClass();
        initLesson();
      } else {
        form.schoolId = null;
        form.lessonId = null;
      }
    };
    var initClass = function initClass() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      classOptions.value = schoolOptions.value[index].deptCommonVOS;
      form.classId = classOptions.value[0].deptId;
    };
    var initLesson = function initLesson() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      lessonOptions.value = classOptions.value[index].lessonLists;
      form.lessonId = lessonOptions.value[0].lessonId;
    };
    getInitData(); // 获取数据

    /** 事件相关 */
    // 前一天
    var changePreDate = function changePreDate() {
      if (dateIndex.value === 0) return;
      dateIndex.value -= 1;
      init();
      handleSearch();
    };
    // 后一天
    var changeNextDate = function changeNextDate() {
      if (dateIndex.value === dateOptions.value.length - 1) return;
      dateIndex.value += 1;
      init();
      handleSearch();
    };
    // 切换学校
    var changeSchool = function changeSchool(val) {
      var index = schoolOptions.value.findIndex(function (x) {
        return x.deptId === val;
      });
      initClass(index);
      initLesson();
      handleSearch();
    };
    // 切换班级
    var changeClass = function changeClass(value) {
      var index = classOptions.value.findIndex(function (x) {
        return x.deptId === value;
      });
      initLesson(index);
      handleSearch();
    };
    /**
     * 查询
     */
    var handleSearch = function handleSearch() {
      emit('handleSearch', {
        lessonId: form.lessonId,
        dateLength: dateOptions.value.length
      });
    };
    return function (_ctx, _cache) {
      var _schoolOptions$value;
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_t_select = _resolveComponent("t-select");
      var _component_t_form_item = _resolveComponent("t-form-item");
      var _component_t_form = _resolveComponent("t-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
        class: _normalizeClass({
          'left-icon': true,
          disabled: dateIndex.value === 0
        }),
        onClick: changePreDate
      }, [_createVNode(_component_svg_icon, {
        name: dateIndex.value === 0 ? 'chevron-left-disable' : 'chevron-left',
        size: "20"
      }, null, 8, ["name"])], 2), _createElementVNode("div", _hoisted_3, _toDisplayString(form.date), 1), _createElementVNode("div", {
        class: _normalizeClass({
          'left-icon': true,
          disabled: dateIndex.value === dateOptions.value.length - 1
        }),
        onClick: changeNextDate
      }, [_createVNode(_component_svg_icon, {
        name: dateIndex.value === dateOptions.value.length - 1 ? 'chevron-right-disable' : 'chevron-right',
        size: "20"
      }, null, 8, ["name"])], 2)]), (_schoolOptions$value = schoolOptions.value) !== null && _schoolOptions$value !== void 0 && _schoolOptions$value.length ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_t_form, {
        data: form,
        layout: "inline"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_t_form_item, {
            label: "学校",
            "label-width": "36px"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_t_select, {
                class: "w-156",
                modelValue: form.schoolId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                  return form.schoolId = $event;
                }),
                options: schoolOptions.value,
                keys: {
                  label: 'name',
                  value: 'deptId'
                },
                onChange: changeSchool
              }, null, 8, ["modelValue", "options"])];
            }),
            _: 1
          }), _createVNode(_component_t_form_item, {
            label: "班级",
            "label-width": "36px"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_t_select, {
                modelValue: form.classId,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                  return form.classId = $event;
                }),
                class: "w-156",
                options: classOptions.value,
                keys: {
                  label: 'name',
                  value: 'deptId'
                },
                onChange: changeClass
              }, null, 8, ["modelValue", "options"])];
            }),
            _: 1
          }), _createVNode(_component_t_form_item, {
            label: "课堂",
            "label-width": "36px"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_t_select, {
                class: "w-156",
                modelValue: form.lessonId,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
                  return form.lessonId = $event;
                }),
                options: lessonOptions.value,
                keys: {
                  label: 'lessonName',
                  value: 'lessonId'
                },
                onChange: handleSearch
              }, null, 8, ["modelValue", "options"])];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["data"])])) : _createCommentVNode("", true)]);
    };
  }
};